module.exports = __webpack_public_path__ + "static/media/Globe.df4661b4.png";